import { apiClient } from '@/lib/api-client';
import type {
  SalesDeliveriesListResponse,
  SalesDelivery,
  SalesDeliveryStatus,
} from '../../domain/entities/delivery.entity';

export interface ListSalesDeliveriesInput {
  page?: number;
  perPage?: number;
  status?: SalesDeliveryStatus;
}

/**
 * Datasource do Delivery Admin — 1 método por endpoint de leitura
 * (`/admin/delivery/*` no monolith).
 */
export class DeliveryApiDatasource {
  async listSalesDeliveries(
    input?: ListSalesDeliveriesInput,
  ): Promise<SalesDeliveriesListResponse> {
    const { data } = await apiClient.get<SalesDeliveriesListResponse>(
      '/admin/delivery/sales-deliveries',
      {
        params: {
          page: input?.page ?? 1,
          perPage: input?.perPage ?? 10,
          ...(input?.status ? { status: input.status } : {}),
        },
      },
    );
    return data;
  }

  async getSalesDelivery(id: string): Promise<SalesDelivery> {
    const { data } = await apiClient.get<SalesDelivery>(
      `/admin/delivery/sales-deliveries/${id}`,
    );
    return data;
  }
}
